module.exports = __webpack_public_path__ + "static/route-fc8d2c4b6e36f0b0639f41eb7a277022.jpg";